import { type ToastId, type UseToastOptions, useToast as useChakraToast } from '@chakra-ui/react'
import { useCallback } from 'react'

const DEFAULT_OPTIONS: Partial<UseToastOptions> = {
  position: 'bottom-right',
  isClosable: true,
}

export const useToaster = (): ((options: UseToastOptions) => ToastId) => {
  const toast = useChakraToast()

  return useCallback(
    (options: UseToastOptions) =>
      toast({
        ...DEFAULT_OPTIONS,
        ...options,
        variant: 'shw',
      }),
    [toast]
  )
}
